<button type="button" (click)="activate()" (keypress.enter)="activate()">
  <mat-icon>language</mat-icon>
</button>
